import '../styles/SearchResultsList.css';
import { CareHome } from '../types';
import OpenScoreCard from './OpenScoreCard';

interface SearchResultsListProps {
    careHomes: CareHome[];
    onSelectCareHome?: (careHome: CareHome) => void;
}



const SearchResultsList = ({ careHomes, onSelectCareHome }: SearchResultsListProps) => {
    if (careHomes.length === 0) {
        return null;
    }

    return (
        <div className="search-results-list">
            <div className="results-container">
                {/* Using composite key to ensure uniqueness across all care homes */}
                {careHomes.map((careHome, index) => (
                    <OpenScoreCard
                        key={`${careHome.id}-${careHome.organisation_id}-${careHome.reg_id}-${index}`}
                        careHome={careHome}
                        onSelect={onSelectCareHome}
                    />
                ))}
            </div>
        </div>
    );
};

export default SearchResultsList;
